<template>
	<div class="login-container">
		<div class="login-form">
			<div class="login-header">
				<h2>宝太脑健康管理系统</h2>
				<p>欢迎登录</p>
			</div>

			<el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form-content">
				<el-form-item prop="username">
					<el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"
						size="medium"></el-input>
				</el-form-item>

				<el-form-item prop="password">
					<el-input v-model="loginForm.password" type="password" placeholder="请输入密码"
						prefix-icon="el-icon-lock" size="medium" @keyup.enter.native="handleLogin"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="medium" :loading="loading" @click="handleLogin" style="width: 100%">
						登录
					</el-button>
				</el-form-item>
			</el-form>

			<div class="login-footer">
				<p>© 2025 宝太脑健康管理系统</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		authAPI
	} from '@/services/api'

	export default {
		name: 'Login',
		data() {
			return {
				loginForm: {
					username: '',
					password: ''
				},
				loginRules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				},
				loading: false
			}
		},
		methods: {
			async handleLogin() {
				// 防止重复提交
				if (this.loading) {
					return
				}

				this.$refs.loginForm.validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
							const response = await authAPI.login(this.loginForm)

							this.$store.dispatch('login', {
								token: response.token,
								userInfo: response.userInfo
							})

							this.$message.success('登录成功')
							this.$router.push('/')
						} catch (error) {
							console.error('登录失败:', error)
							this.$message.error(error.message || '登录失败，请检查用户名和密码')
						} finally {
							this.loading = false
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.login-container {
		height: 100vh;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login-form {
		width: 400px;
		background: white;
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		padding: 40px;
	}

	.login-header {
		text-align: center;
		margin-bottom: 30px;
	}

	.login-header h2 {
		color: #333;
		margin-bottom: 10px;
		font-size: 24px;
	}

	.login-header p {
		color: #666;
		font-size: 14px;
	}

	.login-form-content {
		margin-bottom: 20px;
	}

	.login-footer {
		text-align: center;
		margin-top: 20px;
	}

	.login-footer p {
		color: #999;
		font-size: 12px;
	}
</style>